import { Button, ButtonGroup, Container } from '@mui/material';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import DashBoard from './dashboard';
import History from './History';
import '../../assets/css/default.css';
import ChangePasswordPopUp from './auth/changePasswordPopUp';
import { userSliceActions } from '../../redux/slice/userSlice';
import { useNavigate } from 'react-router';
import { getHistoryListApi } from '../../redux/slice/userSlice';

const Home = () => {
  const dispatch = useDispatch();
  const [isCalculation, setIsCalculation] = useState(true);
  const navigate = useNavigate();
  const changepasswordpopup = useSelector(
    (state: any) => state.user.openChangePasswordPopUpData
  );

  const handleHistoryClick = () => {
    setIsCalculation(false);
    // dispatch(getHistoryListApi({ navigate, rowsPerPage: 10, page: 0 }));
  };

  return (
    <Container maxWidth='lg'>
      <div className={'downloadApkFile'}>
        <ButtonGroup
          variant='contained'
          color='inherit'
          aria-label='outlined light button group'
        >
          <Button
            style={{ backgroundColor: isCalculation ? '#D3D3D3' : '#fff' }}
            onClick={() => setIsCalculation(true)}
          >
            Calculation
          </Button>
          <Button
            style={{ backgroundColor: !isCalculation ? '#D3D3D3' : '#fff' }}
            onClick={handleHistoryClick}
          >
            History
          </Button>
        </ButtonGroup>
        {/* <a
          href={`https://api.b4tax.com.au/B4Tax.apk`}
          className='linkClass'
          download
        >
          Click here to download B4Tax apk (Version 1.0.0)
        </a> */}
      </div>
      {isCalculation ? (
        <DashBoard />
      ) : (
        <History handleBackButton={() => setIsCalculation(true)} />
      )}

      <ChangePasswordPopUp
        open={changepasswordpopup}
        handleClose={() =>
          dispatch(userSliceActions.closeChangePasswordPopUp())
        }
      />
    </Container>
  );
};

export default Home;
